// Import directly from the core implementation to avoid circular deps
import { defineStore } from 'pinia'
import { defaultParams, bestSellersId } from '@/utils/constants'
import { getDeserializedCategories, getDeserializedTiles } from '@/utils/deserialization'

export const useHomepageStore = defineStore('homepage', {
  state: () => ({
    categories: [],
    tiles: [],
    activeCategory: 0,
    homepageMeta: '',
  }),

  actions: {
    setActiveCategory(index) {
      this.activeCategory = index
    },

    async getHomepage(options = {}) {
      const { rootStore = null, $axios = null } = options

      // Handle global loading/error states
      if (rootStore) {
        rootStore.removeError('homepage')
        rootStore.addLoading('homepage')
      }

      // Get axios from nuxt context if not provided
      const axiosInstance = $axios || (process.client && window.$nuxt ? window.$nuxt.$axios : null)

      if (!axiosInstance) {
        if (rootStore) {
          rootStore.addError({ id: 'homepage', error: new Error('No axios instance') })
          rootStore.removeLoading('homepage')
        }
        return
      }

      // Get coupon code from root store if available
      const couponCode = rootStore?.couponCode
      const params = { ...(couponCode && { couponCode }), ...defaultParams }

      try {
        const response = await axiosInstance.get('/homepage', { params })
        const { data: homepage } = response.data
        const deserializedCategories = getDeserializedCategories(homepage, bestSellersId)
        const deserializedTiles = getDeserializedTiles(homepage)

        this.homepageMeta = homepage.meta
        this.categories = deserializedCategories
        this.tiles = deserializedTiles
      } catch (error) {
        if (error.response?.status === 401 && rootStore) {
          // Handle authentication error with silent logout
          await rootStore.silentLogOut({ source: 'homepage/getHomepage' })
          try {
            const response = await axiosInstance.get('/homepage', { params })
            const { data: homepage } = response.data
            const deserializedCategories = getDeserializedCategories(homepage, bestSellersId)
            const deserializedTiles = getDeserializedTiles(homepage)

            this.homepageMeta = homepage.meta
            this.categories = deserializedCategories
            this.tiles = deserializedTiles
          } catch (retryError) {
            if (rootStore) {
              rootStore.addError({ id: 'homepage', error: retryError })
            }
          }
        }

        if (rootStore) {
          rootStore.addError({ id: 'homepage', error })
        }
      } finally {
        if (rootStore) {
          rootStore.removeLoading('homepage')
        }
      }
    },
  },
})
